import Component from '../component/component';

import './tip-selection.scss';

export default class TipSelection extends Component {
    static initSelector: string = '.tip-selection';

    public items: NodeListOf<HTMLElement>;
    public button: HTMLElement;

    constructor(element: HTMLElement) {
        super(element);

        this.items = this.element.querySelectorAll('.tip-selection__item');
        this.button = this.element.querySelector('.tip-selection__button');

        this.init();
    }

    init(): void {
        this.items.forEach((element: HTMLElement) => {
            element.addEventListener('click', this.clickHandler.bind(this));
        });
        this.button.addEventListener('click', this.buttonClickHandler.bind(this));
    }

    clickHandler(event: Event): void {
        event.preventDefault();
        const target: HTMLElement = event.currentTarget as HTMLElement;
        const radio: HTMLInputElement = target.querySelector('.tip-selection__input');
        const isChecked: boolean = radio.checked;

        if (isChecked) {
            radio.checked = false;
        } else {
            radio.checked = true;
        }
    }

    buttonClickHandler(): void {
        this.items.forEach((element: HTMLElement) => {
            const radio: HTMLInputElement = element.querySelector('.tip-selection__input');

            radio.checked = false;
        });
    }
}
